import AbstractCalls from "./AbstractCalls";

class AppCalls extends AbstractCalls {
  async updateBrevoConfig(body) {
    const cmdUri = AbstractCalls.buildCallUri("main", "app/updateBrevoConfig");
    return AbstractCalls.post(cmdUri, body);
  }

  async updateFakturoidConfig(body) {
    const cmdUri = AbstractCalls.buildCallUri("main", "app/updateFakturoidConfig");
    return AbstractCalls.post(cmdUri, body);
  }

  async updateGoPayConfig(body) {
    const cmdUri = AbstractCalls.buildCallUri("main", "app/updateGoPayConfig");
    return AbstractCalls.post(cmdUri, body);
  }

  async testBrevoConfig(body) {
    const cmdUri = AbstractCalls.buildCallUri("main", "app/testBrevoConfig");
    return AbstractCalls.post(cmdUri, body);
  }
}

export default new AppCalls();
